import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ModalXIcon } from '../images/images';
import { colors } from '../styles/colors';
import { FullContainer } from './FullContainer';

interface IState {
    modalWidth: number;
    modalHeight: number;
}

interface IProps {
    justifyContent?: 'center' | 'space-between' | undefined;
    alignItems?: 'center' | undefined;
    onPressExit?(): void;
    style?: {};
    innerContainerStyle?: {};
}

const MARGIN_RATIO = 0.85;
const getModalWidth = () => Math.max(700, window.innerWidth * MARGIN_RATIO);
const getModalHeight = () => Math.max(750, window.innerHeight * MARGIN_RATIO);

export class FullScreenModalContainer extends React.Component<IProps & RouteComponentProps<any>, IState> {
    public state: IState = {
        modalWidth: getModalWidth(),
        modalHeight: getModalHeight(),
    };

    public componentDidMount(): void {
        window.addEventListener('resize', () => this.screenDidResize());
    }

    private screenDidResize(): void {
        const modalWidth = getModalWidth();
        const modalHeight = getModalHeight();

        this.setState({ modalWidth, modalHeight });
    }

    public render() {
        const dynamicInnerContainer = {
            width: this.state.modalWidth,
            justifyContent: this.props.justifyContent,
            alignItems: this.props.alignItems,
        };

        return (
            <FullContainer style={{ ...styles.backgroundColor, ...this.props.style }}>
                <div style={{ ...styles.innerContainer, ...this.props.innerContainerStyle, ...dynamicInnerContainer }}>
                    {this.props.children}

                    {this.props.onPressExit && (
                        <div style={{ ...styles.innerModal, pointerEvents: 'none' }}>
                            <img src={ModalXIcon} style={styles.exitIcon} onClick={this.props.onPressExit} />
                        </div>
                    )}
                </div>
            </FullContainer>
        );
    }
}

const styles = {
    innerContainer: {
        transform: window.innerHeight < 750 ? `scale(0.8)` : window.innerHeight < 900 ? 'scale(0.85)' : 'scale(0.9)',
        backgroundColor: colors.LIGHT_GREY,
        position: 'absolute',
        margin: 'auto',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 900,
        minHeight: 750,
    } as React.CSSProperties,
    backgroundColor: {
        backgroundColor: colors.DARK_BACKGROUND,
        position: 'relative',
    } as React.CSSProperties,
    innerModal: {
        position: 'absolute',
        margin: 'auto',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        cursor: 'pointer',
    } as React.CSSProperties,
    exitIcon: {
        position: 'absolute',
        height: 30,
        width: 30,
        objectFit: 'contain',
        top: 30,
        right: 30,
        zIndex: 1,
        pointerEvents: 'auto',
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/SharedComponents/FullScreenModalContainer.tsx